var _defs, _path, _path2, _path3, _path4, _path5, _path6, _g, _path7, _circle, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Lager_1",
    "data-name": "Lager 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 206.36 42.37",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7 {\n        stroke-width: 0px;\n      }\n\n      .cls-1, .cls-3, .cls-6 {\n        fill-rule: evenodd;\n      }\n\n      .cls-1, .cls-7 {\n        fill: #e63027;\n      }\n\n      .cls-2 {\n        fill: #e30613;\n      }\n\n      .cls-3 {\n        fill: #ffed00;\n      }\n\n      .cls-4 {\n        fill: none;\n      }\n\n      .cls-8 {\n        clip-path: url(#clippath);\n      }\n\n      .cls-5, .cls-6 {\n        fill: #1d1d1b;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 0,
    width: 42.37,
    height: 42.37
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M50.2,7.36h6.16v15.12c0,2.99,1.48,4.72,4.39,4.72s4.46-1.73,4.46-4.72V7.36h6.16v15.08c0,6.98-4.9,10.44-10.73,10.44s-10.44-3.46-10.44-10.44V7.36Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M86.56,12.26c4.93,0,8.85,3.96,8.85,10.29s-3.92,10.37-8.85,10.37c-2.95,0-5.08-1.4-6.19-3.1v12.38h-6.15V12.55h6.15v2.84c1.12-1.76,3.24-3.13,6.19-3.13ZM84.73,17.62c-2.3,0-4.39,1.76-4.39,4.97s2.09,4.97,4.39,4.97,4.43-1.8,4.43-5-2.09-4.93-4.43-4.93Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M115.61,12.55h6.16v20.09h-6.16V12.55Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M152.51,21.73c0-2.63-1.51-4.07-3.85-4.07s-3.85,1.44-3.85,4.07v10.91h-6.12v-10.91c0-2.63-1.51-4.07-3.85-4.07s-3.85,1.44-3.85,4.07v10.91h-6.16V12.55h6.16v2.52c1.19-1.62,3.24-2.74,5.87-2.74,3.02,0,5.47,1.33,6.84,3.74,1.33-2.12,3.85-3.74,6.77-3.74,4.97,0,8.17,3.17,8.17,8.57v11.73h-6.12v-10.91Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M170.88,32.92c-5.9,0-10.15-3.96-10.15-10.33s4.18-10.33,10.15-10.33,10.01,3.89,10.01,10.01c0,.58-.04,1.19-.11,1.8h-13.93c.22,2.63,1.84,3.85,3.82,3.85,1.73,0,2.7-.86,3.2-1.94h6.55c-.97,3.92-4.54,6.95-9.54,6.95ZM166.88,20.65h7.7c0-2.2-1.73-3.46-3.78-3.46s-3.56,1.22-3.92,3.46Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M191.4,32.92c-5.36,0-8.96-2.99-9.25-6.88h6.08c.14,1.4,1.4,2.34,3.1,2.34,1.58,0,2.41-.72,2.41-1.62,0-3.24-10.94-.9-10.94-8.28,0-3.42,2.92-6.23,8.17-6.23s8.06,2.88,8.46,6.84h-5.69c-.18-1.37-1.22-2.27-2.95-2.27-1.44,0-2.23.58-2.23,1.55,0,3.2,10.87.94,10.98,8.42,0,3.49-3.1,6.12-8.14,6.12Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M200.73,8.05h-1.19v-.4h2.86v.4h-1.19v3.17h-.48v-3.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M202.8,7.65h.65l1.13,3,1.13-3h.65v3.57h-.45v-2.97h-.01l-1.12,2.97h-.41l-1.12-2.97h-.01v2.97h-.45v-3.57Z"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M93.98,7.65h19.55v4.93h-6.7v20.34h-6.16V12.58h-6.7v-4.93Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 118.68,
    cy: 7.65,
    r: 3.08
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M21.19.08c11.62,0,21.1,9.48,21.1,21.1s-9.48,21.1-21.1,21.1S.1,32.79.1,21.17,9.57.08,21.19.08"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M21.19,42.28c-2.84,0-5.6-.56-8.2-1.66-2.51-1.07-4.77-2.59-6.71-4.53s-3.47-4.2-4.53-6.71C.64,26.77.08,24.01.08,21.17s.56-5.6,1.66-8.2c1.07-2.51,2.59-4.77,4.53-6.71s4.2-3.47,6.71-4.53C15.59.62,18.35.06,21.19.06s5.6.56,8.2,1.66c2.51,1.07,4.77,2.59,6.71,4.53s3.47,4.2,4.53,6.71c1.1,2.6,1.66,5.36,1.66,8.2s-.56,5.6-1.66,8.2c-1.07,2.51-2.59,4.77-4.53,6.71s-4.2,3.47-6.71,4.53c-2.6,1.1-5.36,1.66-8.2,1.66ZM21.19.09C9.57.09.11,9.55.11,21.17s9.46,21.08,21.08,21.08,21.08-9.46,21.08-21.08S32.82.09,21.19.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M19.48,24.69h3.04l-.8-4.59h-1.46s-.77,4.59-.77,4.59ZM21.51,18.87l-.53-3.05-.5,3.05h1.03ZM23.29,13.15l3.06,14.56h-3.34s-.16-1-.16-1h-3.71l-.19,1.01h-3.31s3.22-14.56,3.22-14.56h4.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M25.39,9.26l1.33.55.48-2.15-.64-.26-1.17,1.87ZM27.33,7.08l.32-1.43-.77,1.24.45.19ZM29.15,4.9l-1.29,6.93-1.46-.6.11-.47-1.63-.67-.27.41-1.45-.6,4.05-5.79,1.94.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M8.65,22.85l-.05-1.44-2.16.46.03.69,2.18.28ZM5.85,21.99l-1.43.31,1.45.18-.02-.49ZM3.11,21.25l6.84-1.71.06,1.58-.47.09.07,1.76.48.07.06,1.57-6.95-1.27-.08-2.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M6.22,15.53l-.42-.14c-.32-.1-.54-.06-.64.26-.11.35.04.48.37.59,1.1.36,2.22-1.99,4.23-1.34,1.23.4,1.57,1.28,1.13,2.62-.33,1.02-.99,1.91-2.11,1.55l-.65-.21.52-1.6.57.19c.38.13.53.03.63-.26.08-.26.03-.46-.36-.59-1.47-.48-2.3,1.97-4.41,1.28-1.18-.38-1.36-1.35-.96-2.58.35-1.08,1-1.89,2.09-1.53l.53.17-.52,1.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M9.36,10.28l-.34-.28c-.26-.21-.48-.24-.69.02-.23.28-.13.47.13.68.9.72,2.78-1.07,4.43.26,1,.81,1.01,1.75.12,2.85-.68.84-1.6,1.43-2.53.69l-.53-.43,1.06-1.31.46.38c.31.25.49.22.69-.02.17-.21.19-.42-.12-.67-1.21-.97-2.85,1.02-4.57-.37-.97-.78-.79-1.75.02-2.76.71-.89,1.61-1.41,2.5-.69l.43.35-1.06,1.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M17.52,5.41l-.11-.43c-.09-.33-.24-.48-.57-.4-.35.09-.38.3-.3.63.3,1.11,2.88.78,3.43,2.82.33,1.25-.22,2.01-1.58,2.37-1.04.28-2.14.21-2.45-.93l-.17-.66,1.63-.43.15.58c.1.39.26.47.57.39.27-.07.4-.23.3-.62-.4-1.5-2.9-.86-3.47-3-.32-1.2.39-1.88,1.65-2.21,1.1-.29,2.13-.19,2.42.92l.14.54-1.63.43Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 12.71,
    y: 5.33,
    width: 1.69,
    height: 6.86,
    transform: "translate(-2.58 8.34) rotate(-31.39)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "19.76 3.97 19.79 2.94 24.38 3.08 24.35 4.12 22.93 4.07 22.74 9.89 21.02 9.84 21.21 4.01 20.22 3.99 19.76 3.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "27.3 30.57 28.57 29.45 32.36 31.58 29.64 28.51 30.71 27.56 35.26 32.71 33.98 33.84 30.18 31.69 32.92 34.78 31.85 35.73 27.3 30.57"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "33.07 7.38 34.24 8.61 32.23 12.47 35.21 9.65 36.19 10.69 31.19 15.4 30.02 14.16 32.05 10.29 29.05 13.13 28.07 12.09 33.07 7.38"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M34.18,19.31h0c-1.21.41-2.04-.13-2.52-1.56-.38-1.13-.34-2.28,1.14-2.77l2.98-1.01c1.48-.5,2.23.4,2.61,1.52.42,1.24.4,2.27-1,2.75l-.71.25-.55-1.64.85-.29s.56-.13.37-.71c-.12-.35-.44-.46-.7-.37l-3.63,1.23h0c-.26.09-.44.36-.32.71.12.37.44.46.7.37l1.08-.37.55,1.62-.85.29Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "26.17 38.72 23.44 32.43 26.84 30.95 27.3 32.01 25.35 32.85 26.03 34.39 27.7 33.67 28.16 34.72 26.48 35.45 27.17 37.03 29.12 36.19 29.57 37.25 26.23 38.7 26.17 38.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "32.54 20.15 39.4 20.38 39.28 24.08 38.13 24.05 38.2 21.93 36.51 21.87 36.45 23.7 35.3 23.66 35.36 21.83 33.64 21.78 33.57 23.9 32.42 23.86 32.53 20.22 32.54 20.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "6.79 32.12 11.64 27.27 12.83 28.47 10.92 30.38 13.83 29.46 14.99 30.63 11.79 31.75 10.15 35.47 8.98 34.31 10.41 30.89 7.99 33.31 6.79 32.12"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M20.33,35.23c1.11,0,1.11-.16,1.11-.88,0-.48,0-.71-1.11-.71h0v1.59ZM18.64,39.35v-6.86h1.69c1.61,0,2.57.16,2.57,1.6.01,1.31-.34,1.37-.89,1.55l-.02.02c.84,0,.92.93.91,1.22v1.5c0,.27.08.69.28.96h-1.46c-.2-.28-.28-.68-.28-.95v-1.14c-.01-.32.11-.76-.83-.76h-.28v2.85h-1.7Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "17.68 32.08 15.89 38.79 14.31 38.04 14.78 36.4 13.87 35.97 12.82 37.33 11.31 36.62 15.73 31.16 17.68 32.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "15.18 35.34 15.95 32.79 14.47 35 15.11 35.3 15.18 35.34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M21.18,42.37C9.5,42.37,0,32.86,0,21.18S9.5,0,21.18,0s21.18,9.5,21.18,21.18-9.5,21.18-21.18,21.18ZM21.18,1.11C10.11,1.11,1.11,10.11,1.11,21.18s9.01,20.08,20.08,20.08,20.08-9.01,20.08-20.08S32.25,1.11,21.18,1.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M21.18,31.33c-5.59,0-10.14-4.55-10.14-10.14s4.55-10.14,10.14-10.14,10.14,4.55,10.14,10.14-4.55,10.14-10.14,10.14ZM21.18,11.37c-5.41,0-9.81,4.4-9.81,9.81s4.4,9.81,9.81,9.81,9.81-4.4,9.81-9.81-4.4-9.81-9.81-9.81ZM21.18,30.52c-5.15,0-9.34-4.19-9.34-9.34s4.19-9.34,9.34-9.34h0c5.15,0,9.33,4.19,9.33,9.34s-4.19,9.34-9.34,9.34ZM21.18,12.17c-4.97,0-9.01,4.04-9.01,9.01s4.04,9.01,9.01,9.01,9.01-4.04,9.01-9.01-4.04-9.01-9.01-9.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M21.18,40.71C10.42,40.71,1.65,31.95,1.65,21.18S10.42,1.66,21.18,1.66s19.53,8.76,19.53,19.53-8.76,19.53-19.53,19.53ZM21.18,2.01C10.61,2.01,2.01,10.61,2.01,21.18s8.6,19.17,19.17,19.17,19.17-8.6,19.17-19.17S31.75,2.01,21.18,2.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M17.53,28.2c.93,0,1.69.76,1.69,1.69s-.76,1.69-1.69,1.69-1.69-.76-1.69-1.69.76-1.69,1.69-1.69"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M18.55,30.48c-.32.55-.89.78-1.54.39-.66-.39-.73-.99-.41-1.54.32-.54.88-.77,1.54-.38.66.39.73.99.41,1.53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M18.02,30.16c.15-.25.09-.53-.19-.7-.28-.16-.55-.07-.7.18-.15.25-.09.53.19.7.28.16.55.07.7-.18"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.9b7c367afadf88b9c318965c949fd846.svg";
export { ForwardRef as ReactComponent };